<template>
  <div class="choose-pay">
    <b>{{ $t("card.pay_method") }}</b>

    <div class="d-flex pt-15 justify-content-between">
      <div
        :class="{
          'pay-option': true,
          active: value == 'cash',
        }"
        @click="$emit('input', 'cash')"
      >
        {{ $t("pay.by_cash") }}
      </div>
      <div
        :class="{
          'pay-option': true,
          active: value == 'card',
        }"
        @click="$emit('input', 'card')"
      >
        {{ $t("pay.by_card") }}
      </div>
    </div>
  </div>
</template>


<script>
export default {
  props: {
    value: String
  }
};
</script>

<style scoped>
.choose-pay {
  width: 100%;
  padding: 2.5vh 5.4vw 0;
}

.pt-15 {
  padding-top: 1.2vh;
}

.choose-pay b {
  font-weight: 400;
  line-height: 0.8;
  font-size: 5vw;
}

.pay-option {
  background: #ededed;
  color: #1d1d1b;
  cursor: pointer;
  width: 47%;
  text-align: center;
  padding: 2.2vh 0;
  font-size: 2.3vh;
  line-height: 0.8;
  border: 2px solid transparent;
  border-radius: 10px;
  font-weight: 600;
  box-shadow: 0px 1px 7px #dadada;
}

.pay-option.active {
  border: 2px solid #129b81;
}

@media screen and (min-width: 768px) {
  .choose-pay b {
    font-size: 3vh;
  }
  .pay-option {
    font-size: 1.8vh;
  }
}
</style>